module.exports = __webpack_public_path__ + "media/activities/art-20d807ad.svg";